<template>
  <div>
    <div class="header">
      <span class="h_back" @click="back"></span>
      <span class="h_title">{{detail.headline}}</span>
    </div>
    <div class="h_msg">
      <div class="h_img">
        <img :src="detail.picUrl" alt="" class="h_imgbg">
      </div>
      <p class="cp_name">{{detail.headline}}</p>
      <span class="cp_time">{{detail.year}}/{{detail.dayMonth}}</span>&nbsp;
      <span class="cp_mum">{{detail.publisher}}</span>
      <div class="cp_content" v-html="msg(detail.content)">

      </div>
    </div>
  </div>
</template>

<script>
  import {api} from '../global/api';
  import { Indicator } from 'mint-ui';
  export default {
    name: "hotDetail",
    data() {
      return {
        id: "",
        detail: {},//详情数据
        newsType: "newshot",
        path: "news"
      }
    },
    mounted() {
      this.init();
    },
    beforeRouteUpdate(to, from, next) {
      // 在当前路由改变，但是该组件被复用时调用
      // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
      // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
      // 可以访问组件实例 `this`
      this.path = to.params.name
    },
    methods: {
      /* watch:{
        $route(to,from){
          if(from.path == '/index') {
           this.path="index"
          } else {
            this.path="news"
          }
        }
      },*/
      msg:function(msg){

        return msg?msg.replace(/&nbsp;/g, ""):"";
      },
      back() {
        // this.$router.go(-1);
        this.$router.back(-1)
      },
      init() {
        let that = this;
        this.id = this.$route.query.id;
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        this.$http.get(api.getArticleById + "?id=" + that.id).then(response => {
          Indicator.close();
          console.log("请求成功了1");
          // console.log(response.data.subjects);
          that.detail = response.data.data.article;
          // console.log(that.showingDates);
        }, response => {
          Indicator.close();
          console.log("请求失败了");
        })
      }
    }
  }
</script>

<style scoped>
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 12rem;
    margin: 0 auto;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .cp_time,.cp_mum{
    height: 0.6rem;
    line-height: 0.6rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.6rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
  }
  .h_chack{
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .off{
    background: url("../../static/images/checkoff.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .on{
    background: url("../../static/images/checkon.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .h_msg{
    width: 17.25rem;
    padding: 1rem .75rem;
    margin-top: 2.25rem;
  }
  .h_img{
    position: relative;
    text-align: center;
  }
  .h_imgbg{
    width: 17.25rem;
    height: 12.95rem;
    border-radius: 0.4rem;
    display: block;
  }
  .recorder{
    position: absolute;
    right: .6rem;
    top: .45rem;
    width: 2.1rem;
    height: 2.1rem;
  }
  .cp_name{
    width: 100%;
   /* height: 0.8rem;*/
    line-height: 0.8rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    margin-top: 1rem;
    margin-bottom: .5rem;
  }
  .cp_base:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .cp_base li{
    float: left;
    width: 7.15rem;
    height: 0.8rem;
    border-radius: 0.4rem;
    margin-right: .75rem;
    margin-bottom: .5rem;
    background-color: rgba(241, 241, 242, 1);
    padding: .5rem .55rem;
  }
  .cp_base li:nth-child(2n){
    margin-right: 0;
  }
  .cp_base img{
    display: inline-block;
    width: .8rem;
    height: .8rem;
  }
  .cp_base span{
    width: 6rem;
    height: 0.8rem;
    line-height:0.8rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    display: inline-block;
    margin-left: .25rem;
  }
  .gotomap{
    width: .34rem;
    height: .6rem;
    position: absolute;
    right:.65rem;
    top: 0;
    bottom:0;
    margin: auto;
  }


  .mum_li{
    position: relative;
  }
  .cp_indroduce{
    width: 3.2rem;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    margin-top: .5rem;
    margin-bottom: .75rem;
  }
  .cp_content{
    width: 100%;
    line-height: 1.2rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: justify;
    font-family: PingFang-SC-Regular;
    margin-top: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/hotDetail.vue